import React from "react";
import { FileUploadStatusWrapperProps } from "./types";
import { Box } from "@origin-digital/ods-core";
import { FileUploadComplete } from "./FileUploadComplete";
import { FileUploadProgressing } from "./FileUploadProgressing";

export const FileUploadStatusWrapper: React.FC<
  FileUploadStatusWrapperProps
> = ({ file, handleRemoveFile }) => {
  return (
    <Box
      padding="medium"
      border="1px solid #F1F1F1"
      borderRadius="small"
      backgroundColor="grey50"
    >
      {file.isUploading ? (
        <FileUploadProgressing file={file} />
      ) : (
        <FileUploadComplete file={file} handleRemoveFile={handleRemoveFile} />
      )}
    </Box>
  );
};
